export default __webpack_public_path__ + "static/media/italian.c71f1ee2.svg";